import * as moment from 'moment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
declare var smartlook;
declare var dataLayer;

@Injectable()
export class AuthService {

  private idToken!: string;
  private expiresAt!: number;

  constructor(public http: HttpClient, private router: Router) { }

  private setIdToken(token: string): void{
    this.idToken = token;
  }

  private setExpiresAt(expiresAt: number): void {
    this.expiresAt = expiresAt;
  }

  public getIdToken(): string {
    return this.idToken;
  }

  public getExpiresAt(): number {
    return this.expiresAt;
  } 

  successLogin(authResult): boolean {
    return this.setSession(authResult);
  }

  private setSession(authResult): boolean {
    // const expiresAt = authResult.exp * 1000;
    const expiresAt = moment.unix(authResult.exp).valueOf();
    this.setIdToken(authResult.token);
    this.setExpiresAt(expiresAt);
    return this.isLoggedIn();
  }

  logout() {
    // this.logoutSmartlook()
    // this.logoutDataLayer()
    this.clearLocalStorage();
  }

  logoutSmartlook() {
    try {
      smartlook('anonymize');
    } catch (error) {
      console.log(error)
    }
  }

  logoutDataLayer() {
    // try {
    //   dataLayer.push(function () { this.reset() })
    // } catch (error) {
    //   console.log(error)
    // }
  }

  public isLoggedIn() {
    let result;
    if (this.getIdToken() === null || this.getIdToken() === undefined) {
      result = false;
    } else if (this.getExpiration() === null) {
      result = false;
    } else {
      result = moment().isBefore(this.getExpiration());
    }
    return result;
  }

  isLoggedOut() {
    return !this.isLoggedIn();
  }

  clearLocalStorage() {
    // for (let x = 0; x <= localStorage.length; x++) {
    //   if (localStorage.key(x) !== "ad_skip") {
    //     localStorage.removeItem(localStorage.key(x));
    //   }
    // }
  }

  getExpiration() {
    let result;
    if (!this.getExpiresAt()) {
      result = null;
    } else {
      result = moment(this.getExpiresAt());
    }
    return result;
  }

  expirationDateDiff() {
    // Valido que no venga nulo
    if (this.getExpiresAt()) {
      const deadline = moment(this.getExpiresAt());
      const now = new Date().getTime();
      const diff = deadline.diff(now, 'days');
      return diff
    }
    return null;
  }

  // METODO QUE EVALUA MITAD DE VIDA DEL TOKEN
  checkTokenHalfLife() {
    const userInfo = this.parseJwt(this.getIdToken());
    const tokenExpiration = this.getExpiresAt() / 1000;
    const tokenHalfLifeUnix = Math.floor((tokenExpiration + userInfo.iat) / 2);
    const todayUnix = moment(new Date()).unix();
    if (todayUnix < tokenHalfLifeUnix) {
      return true;
    }
    if (todayUnix >= tokenHalfLifeUnix && todayUnix < tokenExpiration) {
      return false;
    }
    return null;
  }

  expired() {
    let unix_exp;
    try {
      unix_exp = this.parseJwt(this.getIdToken()).exp;
    } catch (err) {
      return false;
    }
    if (unix_exp != null) {
      const deadline = moment.unix(unix_exp);
      const now = new Date().getTime();

      return (deadline.diff(now) > 0);
    }
    return false;
  }

  parseJwt(token) {
    if (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      return JSON.parse(window.atob(base64));
    }
  }

  getUserFromToken() {
    return this.parseJwt(this.getIdToken());
  }


  getClientFromRoute() {
    const url = this.router.url.slice(1);
    return url.slice(0, url.indexOf('/'));
  }

}
